import { render, staticRenderFns } from "./EditarPuntoDeEntrega.vue?vue&type=template&id=f2bee6ba&"
import script from "./EditarPuntoDeEntrega.vue?vue&type=script&lang=js&"
export * from "./EditarPuntoDeEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports